export const HerosData = {
  home: {
    title: 'YOUR COMPLETE MULTILINGUAL CONTACT CENTER PLATFORM',
    description:
      'iKunnect is a scalable, AI-powered Unified Experience Platform that combines multi-channel commuinication, intelligent automation, and multilingual support. Deliver real-time service, reduce response times, and empower agents to engage customers anywhere.',
  },
  solution: {
    title:
      'Effortless Contact Center Management - Powered by Invictus, Optimized with iKunnect',
    description:
      "Invictus runs your contact center while iKunnect's AI-driven platform optimizes every interaction - boosting efficiency, scalability, and customer satisfaction without the hassle.",
  },
  about: {
    title: ' We empower strategic advantage',
    description:
      ' We provide a comprehensive range of professional services paired with cutting-edge technology to make your contact center more efficient and profitable.',
  },
};
